import { atom } from "jotai"
import moment from "moment";
import Constant from "utils/Constants";
export const INIT_WBS = {
    taskId:null,
    wbsId:null,
    employeeName: "",
    deptId: null,
    deptName: "",
    orgId: null,
    orgName: "",
    divId:null,
    divName:"",
    posId:null,
    status: "",
    orgAddress: "",
    // dateDataCollection: moment().format(Constant.stateDateFormat),
    posResourceTotal: null,
}

export const wbsAtom  = atom(INIT_WBS)
